import { render, staticRenderFns } from "./SingleCommunicationFields.vue?vue&type=template&id=181993e0&scoped=true"
import script from "./SingleCommunicationFields.vue?vue&type=script&lang=ts"
export * from "./SingleCommunicationFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181993e0",
  null
  
)

export default component.exports